import { Component, OnDestroy, ViewChild, } from '@angular/core';
import { BsDatepickerValue, Destroyable$, SystemGuid, TimeFrameTypeDto } from 'webcommon/shared';
import moment from 'moment';
import { ApTimeFrameSelectorModalService } from 'webcommon/core-ui';
import { ColumnExtTimeframeDto} from './ColumnExtTimeframeDto';
import { ApColumnBase } from '../public-api';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsDatepickerConfig, BsDatepickerDirective, DatepickerDateCustomClasses } from 'webcommon/ap-ngx-bootstrap/datepicker';
import { TimeFrameRepository } from 'webcommon/webapi';

@Component({
  selector: 'ap-column-ext-timeframe',
  templateUrl: './ap-column-ext-timeframe.component.html',
  styleUrls: ['./ap-column-ext-timeframe.component.less'],
})

export class ApColumnExtTimeFrameComponent extends ApColumnBase<ColumnExtTimeframeDto>  implements OnDestroy, Destroyable$ {
  readonly onDestroy$: Subject<void> = new Subject<void>();
  dateValue: string | null = null;
  patientId: string;
  dateCustomClasses: DatepickerDateCustomClasses[];
  timeframes: any;

  @ViewChild('calendarDatePicker') calendarDatePicker: BsDatepickerDirective;

    bsConfig: Partial<BsDatepickerConfig> = {
      adaptivePosition: true,
      containerClass: 'theme-emds-datepicker',
      dateInputFormat: 'M/D/YYYY',
      selectFromOtherMonth: true,
      showWeekNumbers: false,
      showTodayButton: true
    };

  timeframe: TimeFrameTypeDto = new TimeFrameTypeDto();
  loading = true;
  formatTimeFrame = '';
  // component: { Id: string; };

  constructor(
    private systemGuid: SystemGuid,
    private apTimeFrameSelectorModalService: ApTimeFrameSelectorModalService,
    private timeFrameRepository: TimeFrameRepository,
  ) {
    super();
    this.loading = true;

    const now = new Date();
    this.dateCustomClasses = [
      { date: now, classes: ['emds-datepicker-current-date-background-color'] },
    ];

    this.bsConfig = Object.assign(
      { containerClass: 'theme-emds-datepicker' },
      { adaptivePosition: true },
      { dateInputFormat: 'M/D/YYYY' },
      { showWeekNumbers: false },
      { selectFromOtherMonth: true },
      { showTodayButton: true }
    );
  }

  takeUntilDestroy<T>() {
    return (source: Observable<T>): Observable<T> => {
      return source.pipe(
        takeUntil(this.onDestroy$),
      );
    };
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  load(): void {
    this.timeframes = this.columnInfoDto.timeFrameDtos.find((x) => x.Name === 'Calendar');
    this.timeframe = this.columnInfoDto.GetExtTimeFrameCallback
      ? this.columnInfoDto.GetExtTimeFrameCallback(this.dataItem)
      : new TimeFrameTypeDto();
    this.formatTimeFrame = this.processTimeFrameDisplayText(this.timeframe);
    this.loading = false;
  }

  setSelected() {
    const el = document.getElementById(this.Id + '-Selected');
    if (el) {
      el.classList.add('pd-selected');
    }
  }

  clickName() {
    this.setSelected();
  }

  clickIcon() {
    this.setSelected();
    if (!this.dataItem.IsDelete && !this.columnInfoDto.IsReadOnly) {
       this.openTimeFrameModel();
    }
  }

  public onCalendarDateChange(value: BsDatepickerValue): void {
    console.log(value);
  }

    // Try to force the calendar to stay open when the Today button is clicked for quick navigation back to the current date.
  // Note: The Today button handler will be called after the bsValueChange handler.

  public attachTodayButtonHandler(): void {
    const todayDiv = document.getElementsByClassName('btn-today-wrapper');
    if (!todayDiv.length) return;
    const todayButton = todayDiv[0].getElementsByTagName('button');
    if (!todayButton.length) return;
    todayButton[0].addEventListener('click', this.onCalendarDatepickerTodayButtonClicked.bind(this));
  }

  private onCalendarDatepickerTodayButtonClicked(): void {
    this.calendarDatePicker.isOpen = true;
  }

  processTimeFrameDisplayText(timeframe: TimeFrameTypeDto) {
    let displayText = '';
    if (timeframe && timeframe.Id) {
      if (timeframe.Id === this.systemGuid.TimeFrame_Calendar) {
        const formattedDate = moment(timeframe.Date).format('L');
        displayText = formattedDate;
      } else if (timeframe.Id === this.systemGuid.TimeFrame_FreeText || timeframe.Id === this.systemGuid.TimeFrame_Default) {
        displayText = timeframe.Value;
      } else if (timeframe.Date) {
        const formattedDate = moment(timeframe.Date).format('L');

        if (formattedDate === timeframe.Answer) {
          displayText = formattedDate;
        } else {
          displayText = `${timeframe.Answer} (${formattedDate})`;
        }
      } else {
          if (timeframe.Id === this.systemGuid.TimeFrame_Clear) {
          displayText = '';
          } else {
            switch (timeframe.Id) {
              case this.systemGuid.TimeFrame_Teenage:
                displayText = 'Teenage';
                break;
              case this.systemGuid.TimeFrame_Birth:
                displayText = 'Birth';
                break;
              case this.systemGuid.TimeFrame_Childhood:
                displayText = 'Childhood';
                break;
              default:
                displayText = '';
            }
          }
      }
    }
    return displayText;
  }

  openTimeFrameModel() {
    const bUsePatient = true;
    const altDate = null;

    let timeframeId;
    let timeframeValue;
    const timeframe = this.timeframe;
    if (timeframe && timeframe.Id !== this.systemGuid.GuidEmpty) {
      timeframeId = timeframe.Id;
      timeframeValue = timeframe.Value;
    } else {
      timeframeId = null;
      timeframeValue = null;
    }

    this.apTimeFrameSelectorModalService.openModal(this.columnInfoDto.PatientId, this.columnInfoDto.VisitId, this.baseId,
                                                    timeframeId, timeframeValue, bUsePatient, altDate, this.columnInfoDto.timeFrameDtos)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        this.onTimeframeChange(result);
      }, () => {
        //
      });
  }

  onTimeframeChange(timeFrame: TimeFrameTypeDto) {
    const result = {dataItem:this.dataItem, timeFrame};
    this.columnInfoDto.Change(result);
  }


  onValueChange() {
    let timeframeId;
    let timeframeValue;
    if (this.timeframes && this.timeframes.TimeFrameId !== this.systemGuid.GuidEmpty) {
      timeframeId = this.timeframes.TimeFrameId;
      if(this.dateValue){
        //this.dateValue = moment(this.dateValue).format('l');
        timeframeId = timeframeId;
        timeframeValue = this.dateValue;
      }
    } else {
      timeframeId = null;
      timeframeValue = null;
    }

    if(timeframeValue){
      this.timeFrameRepository
      .getTimeFrameWithPatient(this.columnInfoDto.PatientId,this.columnInfoDto.VisitId,
        { Id: timeframeId, Value: timeframeValue })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result: TimeFrameTypeDto) => {
        // result.Answer = "Calendar";
        this.onTimeframeChange(result);
      }, () => {
        //
      });
    }
  }
}

